"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskDetails = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../../__generated__/graphql");
const get_task_details_query_1 = require("../gql/get-task-details.query");
const client_utils_1 = require("../../../../client/client.utils");
const store_1 = require("../../../../../store");
const buildTaskKey = (nodeTitle, attributeName) => `${nodeTitle} - ${attributeName}`;
const useTaskDetails = ({ nodeTitle, attributeName }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const shouldSkip = !catalogId || !productTreeId || !nodeTitle || !attributeName;
    const variables = (0, react_1.useMemo)(() => ({
        catalogId,
        productTreeId,
        filter: {
            task: { equals: buildTaskKey(nodeTitle, attributeName) },
        },
    }), [catalogId, productTreeId, nodeTitle, attributeName]);
    const { data, networkStatus, error, refetch, } = (0, react_2.useQuery)(get_task_details_query_1.GET_TASK_DETAILS, {
        variables,
        skip: shouldSkip,
        fetchPolicy: 'cache-first',
        nextFetchPolicy: 'cache-first',
    });
    const taskNode = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.catalog) === null || _a === void 0 ? void 0 : _a.priorityTasks) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node;
    const status = (_e = taskNode === null || taskNode === void 0 ? void 0 : taskNode.status) !== null && _e !== void 0 ? _e : null;
    const escalationReason = (_f = taskNode === null || taskNode === void 0 ? void 0 : taskNode.escalationReason) !== null && _f !== void 0 ? _f : null;
    const instructions = (_g = taskNode === null || taskNode === void 0 ? void 0 : taskNode.instructions) !== null && _g !== void 0 ? _g : null;
    const instructionsUpdatedAt = (taskNode === null || taskNode === void 0 ? void 0 : taskNode.instructionsUpdatedAt) ? String(taskNode.instructionsUpdatedAt) : null;
    const productTreeNodeId = (_h = taskNode === null || taskNode === void 0 ? void 0 : taskNode.productTreeNodeId) !== null && _h !== void 0 ? _h : null;
    const productLabelValidationId = (_j = taskNode === null || taskNode === void 0 ? void 0 : taskNode.productLabelValidationId) !== null && _j !== void 0 ? _j : null;
    // Only show loading for the initial fetch — keep showing cached instructions during any subsequent re-evaluations
    const isLoading = (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    return {
        status,
        isEscalated: status === graphql_1.PriorityTaskStatus.Escalated,
        escalationReason,
        instructions,
        instructionsUpdatedAt,
        productTreeNodeId,
        productLabelValidationId,
        isLoading,
        hasError: !!error,
        refetch,
        queryVariables: shouldSkip ? null : variables,
    };
};
exports.useTaskDetails = useTaskDetails;
